import { GameTable } from '../game-table';
import { TableEvents } from '../table-events.enum';
import { TableEventInfo } from './table-event-info';

export class CardShown extends TableEventInfo {
    getEventType(): TableEvents {
        return TableEvents.CARD_SHOWN;
    }

    next(gameTable: GameTable): void {
        const player = gameTable.getPlayer(this.seat);
        player.addHoleCard(this.card);
        this.card.show = true;
        player.isPlayerCardsOpened = true;
    }

    prev(gameTable: GameTable): void {
        const player = gameTable.getPlayer(this.seat);
        player.removeCard(this.card);
        this.card.show = true;
        player.isPlayerCardsOpened = false;
    }
}
